import { createFileRoute, redirect } from '@tanstack/react-router'
import { selectAuthIsInitialized, selectIsAuthenticated } from '@spcc/domains/auth'
import type { RouterContext } from '@/main'
import { OverviewSection } from '@/components/sections/overview-section'

export const Route = createFileRoute('/')({
  beforeLoad: ({ context, location }) => {
    if (shouldRedirectToLogin(context, location.pathname)) {
      throw redirect({ to: '/login', replace: true })
    }
  },
  component: OverviewPage,
})

function shouldRedirectToLogin(context: RouterContext, pathname: string): boolean {
  if (pathname !== '/') return false
  // Avoid redirecting before auth storage/session has been restored.
  // ProtectedRoute handles the loading state and eventual redirect.
  const isInitialized = selectAuthIsInitialized(context.store.getState())
  if (!isInitialized) return false
  const isAuthenticated = selectIsAuthenticated(context.store.getState())
  return !isAuthenticated
}

function OverviewPage() {
  return <OverviewSection />
}
